import { FormProvider } from 'react-hook-form';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { ControllerWrapper } from '@Hooks/index.ts';
import { EddEmbeddedFields } from '../fields.types';
import { useToWhoYouSellLogic } from './useToWhoYouSellLogic';

export const ToWhoYouSell = () => {
  const { formMethods, handleSubmit } = useToWhoYouSellLogic();
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('embedded.b.question')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'
        handleSubmit={handleSubmit}
        text={t('embedded.b.content')}>
        <ControllerWrapper
          name={EddEmbeddedFields.EDD_EMBEDDED_TO_WHO_YOU_SELL}
          control={formMethods.control}>
          {({ value, onChange, error, onBlur }) => (
            <LiliTextArea
              id={EddEmbeddedFields.EDD_EMBEDDED_TO_WHO_YOU_SELL}
              value={value}
              onValueChange={(val) => onChange(val)}
              errorMsg={error?.message}
              externalErrorMessage={error?.message}
              maxLength={300}
              minHeight='min-h-[174px]'
              onBlur={onBlur}
              placeholder={t('embedded.b.placeholder')}
            />
          )}
        </ControllerWrapper>
      </StepPageWrapper>
    </FormProvider>
  );
};
